<template>
  <b-modal :active.sync="isActive" :width="640" v-if="modeCalculHonoraireClone">
    <div class="card pa-40">
      <div class="card-title has-text-justified px-20">
        <p class="has-text-grid-1 has-text-weight-bold is-size-6">
          {{$t('creerPanneau.modalCalculHonoraire.titleModal')}}
        </p>
        <span class="has-text-default is-size-14px">
          {{$t('creerPanneau.modalCalculHonoraire.subtitle')}}
        </span>
      </div>
      <div class="card-content pa-20">
				<div class="columns is-multiline mgt-20px">
          <div class="column is-6">
            <b-field :label="$t('creerPanneau.modalCalculHonoraire.modeCalcul')">
              <b-select :value="modeCalculHonoraireClone.modeCalcul"
                        @input="updateEnumModeCalcul"
                        expanded>
                <option v-for="mode in constantes.LISTE_MODE_CALCUL"
                        :value="mode.code"
                        :key="mode.code">
                  {{ $t(mode.libelle) }}
                </option>
              </b-select>
            </b-field>
          </div>
          <div class="column is-6">
            <b-field v-if="showInputCurrency"
              :label="getLabelPourcentageOrForfait">
              <input-currency v-model="modeCalculHonoraireClone[getModeCalculToUpdate]" v-if="isModeCalculForfait"/>
							<b-input v-else
								v-model="modeCalculHonoraireClone.pourcentage"
								type="number"
								step="any"
								class="inputHonoraire"/>
            </b-field>
          </div>
          <div class="column is-6"
               v-if="showApplicable">
            <b-field :label="$t('creerPanneau.modalCalculHonoraire.appply')">
              <div class="has-text-default columns is-multiline">
                <b-checkbox v-model="modeCalculHonoraireClone.applicableSurLocation"
                            class="column is-12">
                <span class="has-text-default">
                  {{ $t('creerPanneau.modalCalculHonoraire.loc') }}
                </span>
                </b-checkbox>
                <b-checkbox v-model="modeCalculHonoraireClone.applicableSurTlpe"
                            class="column is-12 pdt-0">
                  {{ $t('creerPanneau.modalCalculHonoraire.tlpe') }}
                </b-checkbox>
                <b-checkbox
                  v-model="modeCalculHonoraireClone.applicableSurDivers"
                  class="column is-12 pdt-0">
                  {{ $t('creerPanneau.modalCalculHonoraire.divers') }}
                </b-checkbox>
              </div>
            </b-field>
          </div>
          <div class="column is-6" v-if="showHonoraireMultiple">
            <b-field
              :label="$t('creerPanneau.modalCalculHonoraire.montantHonoraireForfaitaire')">
              <input-currency v-model="modeCalculHonoraireClone.montantHonoraireForfaitaire">
              </input-currency>
            </b-field>
            <b-field class="mgt-20px"
              :label="$t('creerPanneau.modalCalculHonoraire.montantHonoraireFraisTraitement')">
              <input-currency v-model="modeCalculHonoraireClone.montantHonoraireFraisTraitement">
              </input-currency>
            </b-field>
          </div>
        </div>
      </div>
      <div class="has-text-centered mt-10">
        <b-button
          type="is-transparent"
          class="has-text-default"
          @click="isActive = false">
          {{$t('general.btnAnnuler')}}
        </b-button>
        <b-button
          type="is-primary"
          class="has-text-weight-bold ml-20"
          @click="appliquer">
          {{$t('general.btnAppliquer')}}
        </b-button>
      </div>
    </div>
  </b-modal>
</template>

<script>
import cloneDeep from 'lodash/cloneDeep';
import InputCurrency from '@/components/general/inputCurrency.vue';
import * as tiersConf from '@/configuration/tiers/tiersConf';

export default {
  props: {
    modalIsActive: Boolean,
    modeCalculHonoraire: {
      type: Object,
      required: true,
    },
  },
  components: { InputCurrency },
  data() {
    return {
			modeCalculHonoraireClone: null,
      constantes: {
        LISTE_MODE_CALCUL: tiersConf.LISTE_MODE_CALCUL,
        MODE_CALCUL_POURCENTAGE: tiersConf.MODE_CALCUL_POURCENTAGE,
        MODE_CALCUL_FORFAIT: tiersConf.MODE_CALCUL_FORFAIT,
        MODE_CALCUL_MANUEL: tiersConf.MODE_CALCUL_MANUEL,
      },
    };
  },
  computed: {
    isActive: {
      get() {
        return this.modalIsActive;
      },
      set(value) {
        this.$emit('modalIsClose', value);
      }
    },
    getLabelPourcentageOrForfait() {
      if (this.modeCalculHonoraireClone.modeCalcul === tiersConf.MODE_CALCUL_FORFAIT) {
        return this.$i18n.t('creerPanneau.modalCalculHonoraire.mode.forfait');
      }
      return this.$i18n.t('creerPanneau.modalCalculHonoraire.mode.pourcentage');
    },
    getModeCalculToUpdate() {
      if (this.modeCalculHonoraireClone.modeCalcul === tiersConf.MODE_CALCUL_FORFAIT) {
        return 'montantForfaitHt';
      }
      return 'pourcentage';
    },
		isModeCalculForfait() {
			return this.modeCalculHonoraireClone.modeCalcul === tiersConf.MODE_CALCUL_FORFAIT;
		},
    showApplicable() {
      return [tiersConf.MODE_CALCUL_POURCENTAGE, tiersConf.MODE_CALCUL_MULTIPLE]
        .includes(this.modeCalculHonoraireClone.modeCalcul);
    },
    showInputCurrency() {
      return [tiersConf.MODE_CALCUL_POURCENTAGE, tiersConf.MODE_CALCUL_FORFAIT,
        tiersConf.MODE_CALCUL_MULTIPLE]
        .includes(this.modeCalculHonoraireClone.modeCalcul);
    },
    showHonoraireMultiple() {
      return this.modeCalculHonoraireClone.modeCalcul === tiersConf.MODE_CALCUL_MULTIPLE;
    },
  },
  methods: {
    appliquer () {
      this.$emit('setHonoraires', this.modeCalculHonoraireClone);
      this.isActive = !this.isActive;
    },
    updateEnumModeCalcul(newModeCalcul) {
      if (newModeCalcul === this.modeCalculHonoraireClone.modeCalcul) return;
      this.modeCalculHonoraireClone.applicableSurLocation = false;
      this.modeCalculHonoraireClone.applicableSurTlpe = false;
			this.modeCalculHonoraireClone.applicableSurDivers = false;
      this.modeCalculHonoraireClone.montantForfaitHt = null;
      this.modeCalculHonoraireClone.pourcentage = null;
			this.modeCalculHonoraireClone.montantHonoraireForfaitaire = null;
			this.modeCalculHonoraireClone.montantHonoraireFraisTraitement = null;
      this.modeCalculHonoraireClone.modeCalcul = newModeCalcul;
    },
  },
  mounted() {
    this.modeCalculHonoraireClone = cloneDeep(this.modeCalculHonoraire);
  },
};
</script>

<style>

</style>
